import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { MatSnackBar } from '@angular/material/snack-bar'
import { pagination } from 'src/app/_Common/_Models/pagination';

@Component({
    selector: 'mt-table',
    templateUrl: 'table.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TableComponent implements OnInit, OnChanges {
  @Input() rows: any = [];
  @Input() headers: any = [];
  @Input() extraCols?: any = [];
  @Input() limit: number = 0;
  @Input() offset: number = 0;
  @Input() count: number = 0;
  @Input() checkbox: boolean = false;
  @Input() clearSelection: boolean = false;
  @Input() label: string;
  @Input() shouldCopy: boolean = true;

  @Output() onTableAction = new EventEmitter<any>();
  @Output() onRowClick = new EventEmitter<any>();
  @Output() onSelection = new EventEmitter<any>();
  @Output() singleClick = new EventEmitter<any>();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  selection = new SelectionModel<any>(true, []);
  rowsData: MatTableDataSource<any>;

  selectedData: any = [];
  displayedColumns = [];
  classObj: any = {};
  selectedRowIndex: any;
  totalPage: number = 0
  notFoundMsg: string = null;
  headerDisabled: boolean;
  pagelengths: any = pagination;

  constructor(
    private sb: MatSnackBar
  ) { }

  ngOnInit() {
    this.clearSelection = false;
    if (this.headers && this.headers.length > 1) {
      this.displayedColumns = this.headers.map(col => col.name);
      this.displayedColumns = [...this.extraCols, ...this.displayedColumns];
    }
  }

  ngOnChanges() {
    if (this.rows && this.rows.length > 0) {
      this.selection.clear();
      this.rowsData = new MatTableDataSource(this.rows);
      this.notFoundMsg = null;
      this.totalPage = this.count;
    } else {
      this.notFoundMsg = 'No data to display';
    }
    if (this.clearSelection) {
      this.selection.clear();
      this.clearSelection = false;
    }
  }

  /**
   * Set the sort after the view init since this component will
   * be able to query its view for the initialized sort.
   */
  ngAfterViewInit() {
    if (this.rows && this.rows.length > 0) {
      this.rowsData.paginator = this.paginator;
      this.rowsData.sort = this.sort;

      // If the user changes the sort order, reset back to the first page.
      // this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 1);
    }
  }


  // to get row class name
  getRowClass(row: any) {
    if (row.actionClassName) {
      return row.actionClassName;
    }
    return '';
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    if (this.rows && this.rows.length > 0) {
      const numSelected = this.selection.selected.length;
      const numRows = this.rowsData.data.length;
      if (numSelected !== numRows) this.getSelected(this.selection);
      return numSelected === numRows;
    }
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.rows && this.rows.length > 0) {
      this.isAllSelected() ?
        this.selection.clear() :
        this.rowsData.data.forEach(row => this.selection.select(row));
      this.getSelected(this.selection);
    }
  }
  // disable checkbox
  disabledCheckbox(row: any) {
    if (row && (row.AmountPaidBatchId && row.AmountPaidBatchId !== null) || (row.Slip && row.Slip !== null)) {
      this.headerDisabled = true;
      return true;
    }
    return false;
  }


  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
  }


  getSelected(selected: any) {
    this.onSelection.emit(selected.selected);
  }

  // on click call button
  onBtnAction(row: any) {
    this.onRowClick.emit({ row, type: 'btn' });
  }

  // to highlight the row
  highlightRow(row: any) {
    this.selectedRowIndex = row.id;
  }

  // for pagination
  onPage($event: any) {
    const { offset, limit } = $event;
    const pageObj = {
      limit,
      offset
    };
    this.onTableAction.emit({ pageObj, page: true });
  }

  // on sorting
  onSort($event: any) {
    const { direction, active } = $event;
    const index = this.headers.findIndex(obj => obj.name === active);
    if (this.headers[index].sortable && ["desc", "asc"].includes(direction)) {
      const sortProp = this.headers[index].prop;
      const pageObj: any = {
        orderin: direction,
        orderby: sortProp,
        offset: 0
      }
      this.onTableAction.emit({ pageObj, sort: true })
    }
  }

  // to access the timeline
  gotToTimeline(row: any) {
    this.onRowClick.emit({ row, type: 'dir' });
  }
  onRowClickAction(row: any) {
    this.singleClick.emit(row);
  }

  // click to copy text
  onCopy(name: string, event$: boolean) {
    if (this.shouldCopy) {
      if (event$) {
        this.sb.open(`${name} has been copied to clipboard`, 'okay', {
          duration: 2000,
          panelClass: ['success']
        })
      }
    }
  }
}
